module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"errorCode":"Código do erro:"},"en-US":{"errorCode":"Error code:"}}')
  delete Component.options._Ctor
}
